/**
 * app/(marketing)/legal/refunds.tsx - getabeam.com Refund and Return Policy (web, public).
 * Content lives in src/marketing/legal.ts; rendering in src/marketing/legalPage.tsx.
 */
import { LegalPage } from '../../../src/marketing/legalPage';
import { legalDocBySlug } from '../../../src/marketing/legal';

export default function RefundsScreen() {
  return <LegalPage doc={legalDocBySlug('refunds')} />;
}
